import React, { useState, useEffect, useRef } from 'react';
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import organisms from "../../../../components/organisms";
import service from '../../../../api/services';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import constant from '../../../../constants/constant';
import { useToasts } from 'react-toast-notifications';
import { getDropdownValue, convertArrayToKeyValue, getParams } from '../../../../constants/utils';
import { BrandDataProps, ProductStateType, ProductTypeProps } from './interface';
import useDropDown from './hooks/useDropDown';
import fetchProductByModel from './hooks/useApi';
import { useProduct } from './hooks/useAddProduct';

const { AddProduct } = organisms
const AddProducts = () => {
    let debounce: any;
    const { calculateORP } = useProduct()
    const searchTabContainer = useRef<HTMLDivElement>(null);
    const [previewTab, setPreviewTab] = useState<boolean>(false)
    const { getProductTypeDropdown, getBrandDropdown, getSpecxColorDropdown, getProductMaterialDropdown, findArrayForDefaultValue } = useDropDown()
    const navigate: any = useNavigate()
    const { addToast } = useToasts();
    const [productType, setProductType] = useState<ProductTypeProps[]>([])
    const [deleteClick, setDeleteClick] = useState<boolean>(false)
    const [brand, setBrand] = useState<ProductTypeProps[]>([])
    const [brandResponse, setBrandResponse] = useState<BrandDataProps[]>([])
    const [productShape, setProductShape] = useState([])
    const [previewImageUrl, setPreviewImageUrl] = useState<string[]>([])
    const [productMaterial, setProductMaterial] = useState([])
    const [productColor, setProductColor] = useState([])
    const [glassSizes, setGlassSizes] = useState<any>([])
    const [power, setPower] = useState<any>([])
    const [templeSizes, setTempleSizes] = useState<any>([])
    const [bridgeSizes, setBridgeSizes] = useState<any>([])
    const [productDataByModel, setProductDataByModel] = useState([])
    const [isContactLensProduct, setIsContactLensProduct] = useState<any>(false)
    let params = useParams();
    let productEditID = params.id || ''
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const isDuplicateValue = searchParams.get('isDuplicate');
    const [typeValue, setTypeValue] = useState<any>(getParams('add-type'));
    const [toggleProductOrp, setToggleProductOrp] = useState<boolean>(false);
    const [orpUpdateFlags, setOrpUpdateFlags] = useState({
        isSRPUpdate: false,
        isORPUpdate: false
    })
    const [productData, setProductData] = useState<any>({
        isActive: false,
        product_id_display: '',
        modal_number: "",
        brand_color_code: '',
        brand_color_name: '',
        specx_colors: [],
        lens_colors: [],
        glass_size: '',
        temple_size: '',
        bridge_size: '',
        product_with_case: false,
        description: '',
        product_srp: '',
        features: [],
        rim_type: '',
        gender: [],
        warranty: '',
        weight: '',
        product_type_id: '',
        brand_id: '',
        product_materials: [],
        shapes: [],
        images: [],
        cover_index: 0,
        isPolarised: '',
        productDescription: "",
        lens_type: '',
        lens_name: '',
        period_use: '',
        pack_of_quantity: 0,
        color_id: '',
        product_orp: '',
    })
    const getDropdown = (response: []) => {
        let dropdown: any = []
        response && response.map((value: any) => {
            dropdown.push({
                "value": value.id || value.product_type.id,
                "label": value.name || value.brand_name || value.color_name || value.product_type.name,
                "code": value?.brand_code || value?.product_type_initials || value?.product_type?.product_type_initials,
                'brand-type': value.brand_type || 1
            }
            )
        })
        return dropdown
    }

    const getProductData = async () => {
        try {
            let productShapeResponse = await service.productData.commonProductShapeListingService({})
            let productMaterialResponse = await service.productData.commonProductMaterialListingService({})
            let productColorResponse = await service.productData.commonProductColorListingService({})
            let brandResponse: { data: { data: BrandDataProps[] } } = await service.productData.commonBrandListingService({
                brand_category: typeValue || constant.BRAND_CATEGORY[0].value
            })
            let sidesResponse = await service.productData.sizeDetails()

            setGlassSizes(convertArrayToKeyValue(sidesResponse?.data.data.glass_size))
            setPower(convertArrayToKeyValue(sidesResponse?.data.data.powers))
            setTempleSizes(convertArrayToKeyValue(sidesResponse?.data.data.temple_size))
            setBridgeSizes(convertArrayToKeyValue(sidesResponse?.data.data.bridge_size))
            setBrandResponse(brandResponse?.data?.data)
            setBrand(getBrandDropdown(brandResponse?.data?.data))
            setProductShape(getDropdown(productShapeResponse?.data?.data))
            setProductMaterial(getDropdown(productMaterialResponse?.data?.data))
            setProductColor(getDropdown(productColorResponse?.data?.data))
            if (productEditID?.length > 0) {
                getEditData(getBrandDropdown(brandResponse.data.data),
                    brandResponse.data.data,
                    getDropdown(productShapeResponse?.data?.data), getDropdown(productColorResponse?.data?.data))
            }
        } catch (error) {
            console.error(error)
        }
    }


    const addProducts = async () => {

        const formdata: any = new FormData();
        let singleKey: string[] = ['rim_type', 'warranty', 'weight', 'product_type_id',
            'brand_id', 'isPolarised', 'glass_size', 'temple_size', 'bridge_size', 'lens_type', 'period_use', 'color_id']
        let multiKey: string[] = ['product_materials', 'features', 'specx_colors', 'lens_colors',
            'shapes', 'gender',]
        for (const key in productData) {
            if (productData.hasOwnProperty(key) && productData[key] !== undefined &&
                productData[key] !== '' && productData[key] !== null) {

                if (singleKey.includes(key)) {
                    formdata.append(key, productData[key].value)
                } else if (multiKey.includes(key)) {
                    productData[key].forEach((item: any) => formdata.append(key, item.value));
                } else if (key === 'images') {
                    productData?.images.forEach((image: any) => formdata.append('product_images', image))
                } else if (key === 'product_orp') {
                    const modifiedOrp: number = calculateORP({
                        orp: productData[key],
                        srp: productData.product_srp,
                        id: productEditID,
                        isORPUpdate: orpUpdateFlags?.isORPUpdate,
                        isSRPUpdate: orpUpdateFlags?.isSRPUpdate,
                        toggleProductOrp
                    })
                    formdata.append(key, modifiedOrp);
                } else {
                    formdata.append(key, productData[key]);
                }
            }
        }
        formdata.append('is_contact_lens', isContactLensProduct)
        try {
            if (isDuplicateValue) {
                let response = await service.product.add(formdata, { "Content-type": "multipart/form-data" })
                if (response.status === 201) {
                    addToast('Product Duplicate successfully', {
                        appearance: 'success',
                        autoDismiss: true,
                        autoDismissTimeout: 3000,
                    });
                    // navigate(`/products/pending?pending-type=${typeValue}`)
                    navigate(-1)
                }
            } else {
                if (productEditID) {
                    let response = await service.product.edit(productEditID, formdata, { "Content-type": "multipart/form-data" })
                    if (response.status === 200) {
                        addToast('Product updated successfully', {
                            appearance: 'success',
                            autoDismiss: true,
                            autoDismissTimeout: 3000,
                        });
                        localStorage.setItem("isContactLensProduct", JSON.stringify(isContactLensProduct));
                        navigate(-1);
                    }
                } else {
                    let response = await service.product.add(formdata, { "Content-type": "multipart/form-data" })
                    if (response.status === 201) {
                        addToast('Product Add successfully', {
                            appearance: 'success',
                            autoDismiss: true,
                            autoDismissTimeout: 3000,
                        });
                        localStorage.setItem("isContactLensProduct", JSON.stringify(isContactLensProduct));
                        navigate(`/products/pending?pending-type=${typeValue}`)
                    }
                }
            }
        } catch (error: any) {
            console.error("error", error);
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }
    const getEditData = async (brand: any, brandResponseData: any, shape: any, colors: any) => {
        let productData
        try {
            let response = await service.product.getDetailById(productEditID)
            if (response?.data?.data?.brand?.id && brandResponse) {
                const filteredData: any = brandResponseData.filter((item: any) => item?.id === response?.data?.data?.brand?.id);
                productData = getDropdown(filteredData[0]?.product_types)
                let productTypeOption = getProductTypeDropdown(filteredData[0]?.product_types)
                setProductType(productTypeOption)
                setIsContactLensProduct(response?.data?.data?.is_contact_lens)
                handleEditData(response, brand, productData, shape, colors, productTypeOption)
            }

        } catch (error) {
            console.error("error: ", error)
        }
    }

    useEffect(() => {
        getProductData()
    }, [typeValue])
    useEffect(() => {
        if (deleteClick) {
            deleteProduct()
        }
    }, [deleteClick])

    const getDropdownData = (response: any, constant_key: any) => {
        let tempArr: any = []
        response && response?.map((data: any) => {
            constant_key.map((item: any) => {
                if (data === item.value) {
                    tempArr?.push(item)
                }
            })
        })
        return tempArr
    }

    //function to find the code of product type
    const getProductCode = (id: string, constArray: ProductTypeProps[]): string => {
        return constArray?.find((item) => item?.value === id)?.code || ''
    }
    //end

    const handleEditData = (response: any, brandData: any, type: any, shape: any, colors: any, productTypeOption: ProductTypeProps[]) => {
        setPreviewImageUrl(response.data.data.images)
        let editProductData: any = {
            isActive: response?.data?.data?.isActive,
            product_id_display: response?.data?.data?.product_id_display,
            modal_number: response?.data?.data?.modal_number,
            brand_color_code: response?.data?.data?.brand_color_code,
            brand_color_name: response?.data?.data?.brand_color_name,
            pack_of_quantity: response?.data?.data?.pack_of_quantity,

            lens_name: response?.data?.data?.lens_name,
            glass_size: {
                "value": response?.data?.data?.glass_size,
                "label": response?.data?.data?.glass_size,
            },
            temple_size: {
                "value": response?.data?.data?.temple_size || '',
                "label": response?.data?.data?.temple_size || '',
            },
            bridge_size: {
                "value": response?.data?.data?.bridge_size || '',
                "label": response?.data?.data?.bridge_size || '',
            },
            product_srp: response?.data?.data?.product_srp,
            product_orp: response?.data?.data?.orp,
            product_with_case: response?.data?.data?.product_with_case,
            productDescription: response?.data?.data?.description,
            cover_index: response?.data?.data?.cover_index,

            warranty: {
                "value": getDropdownValue(constant.PRODUCT_WARRANTY, response?.data?.data?.warranty).value,
                "label": getDropdownValue(constant.PRODUCT_WARRANTY, response?.data?.data?.warranty).label,
            },
            isPolarised: {
                "value": getDropdownValue(constant.POLARIZED, response?.data?.data?.isPolarised).value,
                "label": getDropdownValue(constant.POLARIZED, response?.data?.data?.isPolarised).label,
            },
            weight: response?.data?.data?.weight ? {
                "value": getDropdownValue(constant.PRODUCT_WEIGHT, response?.data?.data?.weight).value,
                "label": getDropdownValue(constant.PRODUCT_WEIGHT, response?.data?.data?.weight).label,
            } : null,
            rim_type: {
                "value": getDropdownValue(constant.PRODUCT_RIM_TYPE, response?.data?.data?.rim_type).value,
                "label": getDropdownValue(constant.PRODUCT_RIM_TYPE, response?.data?.data?.rim_type).label,
            },
            // productType
            product_type_id: {
                "value": response?.data?.data?.product_type?.id,
                "label": response?.data?.data?.product_type?.name,
                "code": getProductCode(response?.data?.data?.product_type?.id, productTypeOption),
            },
            lens_type: {
                "value": getDropdownValue(constant.LENS_TYPE, response?.data?.data?.lens_type).value,
                "label": getDropdownValue(constant.LENS_TYPE, response?.data?.data?.lens_type).label,
            },
            period_use: {
                "value": getDropdownValue(constant.PERIOD_USE, response?.data?.data?.period_use).value,
                "label": getDropdownValue(constant.PERIOD_USE, response?.data?.data?.period_use).label,
            },
            color_id: {
                "value": getDropdownValue(colors, response?.data?.data?.color_id)?.value,
                "label": getDropdownValue(colors, response?.data?.data?.color_id)?.label,
            },
            // TODO: If This page cash remove the "code" from here as well as from utils function ;)
            brand_id: {
                "value": getDropdownValue(brandData, response?.data?.data?.brand?.id).value,
                "label": getDropdownValue(brandData, response?.data?.data?.brand?.id).label,
                "code": getDropdownValue(brandData, response?.data?.data?.brand?.id).code,
            },
            gender: getDropdownData(response?.data?.data?.gender, constant.GENDER),
            shapes: getDropdown(response?.data?.data?.shapes),
            specx_colors: getDropdown(response?.data?.data?.specx_colors),

            lens_colors: getDropdown(response?.data?.data?.lens_colors),
            features: getDropdownData(response?.data?.data?.features, constant.PRODUCT_FEATURES),
            product_materials: getProductMaterialDropdown(response?.data?.data?.product_materials),
            images: response?.data?.data?.images
        }
        if (response?.data?.data?.orp && (response?.data?.data?.product_srp !== response?.data?.data?.orp)) {
            setToggleProductOrp(true)
        }
        setProductData(editProductData)
    }

    const deleteProduct = async () => {
        try {
            let response = await service.product.delete(productEditID)
            if (response.status === 200) {
                addToast('Product Delete successfully', {
                    appearance: 'success',
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
                localStorage.setItem("isContactLensProduct", JSON.stringify(isContactLensProduct));
                navigate(-1)
            }
        } catch (error: any) {
            console.error("error", error);
            addToast(error.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }

    // INFO:- function to make select the model item
    const handleModelSelect = async(item: ProductStateType) => {
        setPreviewImageUrl(item?.images)
        let productColorResponse = await service.productData.commonProductColorListingService({})
        const colors = getDropdown(productColorResponse?.data?.data)
        let editProductData: any = {
            isActive: item?.isActive,
            product_id_display: item?.product_id_display,
            modal_number: item?.modal_number,
            brand_color_code: item?.brand_color_code,
            brand_color_name: item?.brand_color_name,
            pack_of_quantity: item?.pack_of_quantity,

            lens_name: item?.lens_name,
            glass_size: {
                value: item?.glass_size,
                label: item?.glass_size,
            },
            temple_size: item?.temple_size ? {
                value: item?.temple_size || '',
                label: item?.temple_size || '',
            } : null,
            bridge_size: item?.bridge_size ? {
                value: item?.bridge_size || '',
                label: item?.bridge_size || '',
            } : null,
            product_srp: item?.product_srp,
            product_orp: item?.orp,
            product_with_case: item?.product_with_case,
            productDescription: item?.description,
            cover_index: item?.cover_index,

            warranty: {
                value: getDropdownValue(constant.PRODUCT_WARRANTY, item?.warranty).value,
                label: getDropdownValue(constant.PRODUCT_WARRANTY, item?.warranty).label,
            },
            isPolarised: {
                value: getDropdownValue(constant.POLARIZED, item?.isPolarised).value,
                label: getDropdownValue(constant.POLARIZED, item?.isPolarised).label,
            },
            weight: item?.weight ? {
                value: getDropdownValue(constant.PRODUCT_WEIGHT, item?.weight).value,
                label: getDropdownValue(constant.PRODUCT_WEIGHT, item?.weight).label,
            } : null,
            rim_type: {
                value: getDropdownValue(constant.PRODUCT_RIM_TYPE, item?.rim_type).value,
                label: getDropdownValue(constant.PRODUCT_RIM_TYPE, item?.rim_type).label,
            },
            lens_type: {
                value: getDropdownValue(constant.LENS_TYPE, item?.lens_type).value,
                label: getDropdownValue(constant.LENS_TYPE, item?.lens_type).label,
            },
            period_use: {
                value: getDropdownValue(constant.PERIOD_USE, item?.period_use).value,
                label: getDropdownValue(constant.PERIOD_USE, item?.period_use).label,
            },
            color_id: {
                "value": getDropdownValue(colors, item?.color_id)?.value,
                "label": getDropdownValue(colors, item?.color_id)?.label,
            },
            gender: getDropdownData(item?.gender, constant.GENDER),
            shapes: findArrayForDefaultValue(item?.shapes, productShape),
            specx_colors: findArrayForDefaultValue(item?.specx_colors, productColor),
            lens_colors: findArrayForDefaultValue(item?.lens_colors, productColor),
            features: getDropdownData(item?.features, constant.PRODUCT_FEATURES),
            product_materials: findArrayForDefaultValue(item?.product_materials, productMaterial),
            images: item?.images
        };
        if (item?.orp && (item?.product_srp !== item?.orp)) {
            setToggleProductOrp(true)
        }
        setProductData((prevState: ProductStateType) => ({
            ...prevState,
            ...editProductData
        }));
        setPreviewTab(!previewTab)
    }
    // end

    // INFO:- function to call the model search api to get product detail and apply debounce
    const handleModelSearchDebounce = (searchVal: string) => {
        clearTimeout(debounce)
        debounce = setTimeout(() => {
            fetchProductByModel({
                brand_id: productData?.brand_id?.label,
                product_type_id: productData?.product_type_id?.label,
                search: searchVal,
                setProductDataByModel
            })
            setPreviewTab(true)
        }, 1000);
    }
    // end

    // INFO: function to handle click outside the model search tab
    const handleClickOutside = (event: any) => {
        if (searchTabContainer.current && !searchTabContainer.current.contains(event.target)) {
            setPreviewTab(false);
        }
    };
    // end

    // INFO:- useEffect to handle the outside click of model field
    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    // end


    return (
        <Wrapper>
            <AddProduct
                productData={productData}
                setProductData={setProductData}
                productType={productType}
                brand={brand}
                productShape={productShape}
                productMaterial={productMaterial}
                productColor={productColor}
                glassSizes={glassSizes}
                power={power}
                templeSizes={templeSizes}
                bridgeSizes={bridgeSizes}
                imageUrl={previewImageUrl}
                setDeleteClick={setDeleteClick}
                brandResponse={brandResponse}
                setProductType={setProductType}
                isDuplicateValue={isDuplicateValue}
                addProducts={() => { addProducts() }}
                isContactLensProduct={isContactLensProduct}
                setIsContactLensProduct={setIsContactLensProduct}
                getProductTypeDropdown={getProductTypeDropdown}
                productDataByModel={productDataByModel}
                fetchProductByModel={(searchVal: string) => handleModelSearchDebounce(searchVal)}
                handleModelSelect={handleModelSelect}
                searchTabContainer={searchTabContainer}
                previewTab={previewTab}
                setPreviewTab={setPreviewTab}
                toggleProductOrp={toggleProductOrp}
                setToggleProductOrp={setToggleProductOrp}
                setOrpUpdateFlags={setOrpUpdateFlags}
                orpUpdateFlags={orpUpdateFlags}
            />
        </Wrapper>
    )
}
export default AddProducts